import * as React from 'react';

import { useRouter } from 'expo-router';
import { StyleSheet } from 'react-native';

import { ActionButtonVariants } from 'components/action-button';
import { Box } from 'components/ui';
import { LogUserErrorSeverity, useLogUserErrorMessage } from 'hooks/log-user-error-message';
import { t } from 'state/intl/translations';
import { layout, spacing } from 'styles/constants';
import { routes } from 'utils/routing';

import { ModalContent } from '../styled';

import { LoadingText, StyledActionButton } from './styled';
import { IDeliveryUnavailableProps } from './types';

/**
 *
 * DeliveryUnavailable informs the guest that the address they entered
 * is unable to receive delivery at this time
 *
 */

export const DeliveryUnavailable: React.FC<React.PropsWithChildren<IDeliveryUnavailableProps>> = ({
  address,
  close,
}) => {
  const router = useRouter();

  useLogUserErrorMessage({
    message: 'delivery-unavailable-for-address',
    severity: LogUserErrorSeverity.Irrecoverable,
  });

  return (
    <Box testID="delivery-unavailable-for-address" style={styles.container}>
      <ModalContent>
        <LoadingText>{t('cannotDeliveryTo')}</LoadingText>
        <LoadingText>{address}</LoadingText>
        <Box style={styles.buttonContainer}>
          <StyledActionButton
            fullWidth
            onPress={() => {
              router.replace({
                pathname: routes.storeLocator,
                params: { redirectUrl: routes.menu },
              });
            }}
          >
            {t('orderPickup')}
          </StyledActionButton>
        </Box>
        <Box style={styles.buttonContainer}>
          <StyledActionButton
            testID="use-different-address"
            fullWidth
            onPress={close}
            variant={ActionButtonVariants.OUTLINE}
          >
            {t('useDifferentAddress')}
          </StyledActionButton>
        </Box>
      </ModalContent>
    </Box>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    marginTop: spacing.$4,
    width: layout.full,
  },
  container: {
    alignItems: 'center',
  },
});
